<template>
    <div class="auth-layout">
        <div class="logo">
            <img src="@/images/logo-dark.svg" style="width: 82px; height: 24px" />
        </div>
        <div class="content">
            <router-view data-slot="targetContent"></router-view>
        </div>
    </div>
</template>
<script>
export default {
    name: 'AuthLayout',
}
</script>
<style>
.auth-layout {
    .logo {
        padding: 112px 64px;
    }

    .content {
        display: flex;
        flex-direction: column;
        align-items: center;
    }
}
</style>
